import React from 'react';
import { Box, Tooltip } from '@mui/material';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import { colors, typography } from '../../../styles/theme';
import { COLLECTION_LEADS_BUTTON_LABEL, describeUnseenLeads } from '../../../Leads/leadCollections';

const labelSx = {
  fontSize: '11px',
  fontWeight: 600,
  fontFamily: typography.fontFamily.primary,
  lineHeight: 1,
  whiteSpace: 'nowrap',
};

/**
 * Detalle de lista (owner / editor de Espacio): píldora “Leads y consultas”
 * con el mismo chrome que `CollectionInquiryBadge` (borde, ícono en primary,
 * número nuevo en píldora primary). Ícono = el de Leads en el rail. El
 * número es `unseen_leads` (leads con consultas sin ver); con 0 no se muestra.
 * Abre el modal LEADS Y CONSULTAS de esa lista.
 *
 * Oculto por decisión de la meet del 2026-10-15: no se usa por ahora
 * (utilidad muy puntual). Reactivar si se necesita.
 * (`SHOW_COLLECTION_LEADS_FROM_LIST_DETAIL`).
 *
 * @param {{ unseen?: number, onClick: () => void, sx?: object }} props
 */
export default function CollectionLeadsButton({ unseen = 0, onClick, sx = undefined }) {
  const unseenText = describeUnseenLeads(unseen);
  const count = unseenText ? Math.trunc(Number(unseen)) : 0;
  const ariaLabel = unseenText
    ? `${COLLECTION_LEADS_BUTTON_LABEL}: ${unseenText}`
    : COLLECTION_LEADS_BUTTON_LABEL;
  return (
    <Tooltip title={unseenText || 'Ver leads y consultas de esta lista'} placement="top" arrow>
      <Box
        component="button"
        type="button"
        onClick={onClick}
        aria-label={ariaLabel}
        data-testid="collection-leads-button"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.75,
          minWidth: 0,
          flexShrink: 0,
          py: 0.5,
          pl: 1,
          pr: count ? '3px' : 1.25,
          m: 0,
          borderRadius: '999px',
          border: `1px solid ${colors.border}`,
          bgcolor: 'transparent',
          color: colors.textSecondary,
          boxSizing: 'border-box',
          cursor: 'pointer',
          font: 'inherit',
          '&:hover': { bgcolor: 'rgba(255,255,255,0.04)' },
          '&:focus-visible': { outline: `2px solid ${colors.primary}`, outlineOffset: 2 },
          ...sx,
        }}
      >
        <PersonAddOutlinedIcon sx={{ fontSize: 14, color: colors.primary, flexShrink: 0 }} />
        <Box component="span" sx={{ ...labelSx, color: colors.textSecondary }}>
          {COLLECTION_LEADS_BUTTON_LABEL}
        </Box>
        {count ? (
          <Box
            component="span"
            data-testid="collection-leads-unseen"
            sx={{
              ...labelSx,
              display: 'inline-flex',
              alignItems: 'center',
              height: 20,
              minWidth: 20,
              justifyContent: 'center',
              px: 0.75,
              borderRadius: '999px',
              bgcolor: colors.primary,
              color: colors.textPrimary,
            }}
          >
            {count}
          </Box>
        ) : null}
      </Box>
    </Tooltip>
  );
}
